import TooltipIcon from './TooltipIcon';
import Icon from 'components/icon';

// eslint-disable-next-line react/prop-types
const InformationTooltip = ({ label, iconProp }) => {
  return (
    <TooltipIcon placement={'bottom'} label={label} className="text-600 ms-1">
      <Icon fontSize="17px" icon={'ph:info'} {...iconProp} />
    </TooltipIcon>
  );
};

export default InformationTooltip;
